import React from 'react';

import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { linkTo } from '@storybook/addon-links';

import { Welcome } from '@storybook/react/demo';
import { AssociatedCasesView } from './AssociatedCasesView';

 storiesOf('Case Menu/Associated Cases', module)
  .add('Showing', () =>
    <div>
      <h3> Associated Cases view wth data </h3>
      <hr/>
      <AssociatedCasesView
        associatedCases={associatedCases.data.associated_cases}
      />
    </div>
  )
  .add('Empty', () => (
    <div>
      <h3> Associated Cases Empty</h3>
      <hr/>
      <AssociatedCasesView
        associatedCases={associatedCasesEmpty.data.associated_cases}
      />
    </div>
  ))

  const associatedCases= {
    data: {
      associated_cases: [
      {
        associated_case: {
          case_code: "05-06235-fra",
          case_id: "190584",
          case_name: "Sticka v. Allied Building Products Corp",
          case_type: "Adversary",
          case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?190584",
          case_uuid: "orbke_190584",
        },
        case: {
           case_code: "04-63199-fra7",
           case_id: "154519",
           case_name: "A & B Davis, Inc",
           case_title: "A & B Davis, Inc",
           case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?154519",
           case_uuid: "orbke_154519",
           date_closed: null,
        }
      },
      {
        associated_case: {
          case_code: "05-06244-fra",
          case_id: "191104",
          case_name: "Sticka v. Custom Bilt Metals Inc.",
          case_type: "Adversary",
          case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?191104",
          case_uuid: "orbke_191104",
        },
        case: {
          case_code: "04-63199-fra7",
          case_id: "154519",
          case_name: "A & B Davis, Inc",
          case_title: "A & B Davis, Inc",
          case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?154519",
          case_uuid: "orbke_154519",
          date_closed: null,
        }
      },
    ]
   }
 }

  const associatedCasesEmpty= {
    data: {
      associated_cases: {
         'empty' : "There are no associateds cases. "
       },
    }
  }




// WEBPACK FOOTER //
// ./src/components/case/associated_cases/AssociatedCasesView.stories.jsx